import React from 'react'

export default function ImageViewer({ url, width, height, top }) {
  return (
    <div style={{ width, height, position: 'absolute', left: '50%', transform: `translate(-50%,${top}px)` }}>
      <img src={url} style={{ width: '100%' }} alt="" />
    </div>
  )
}
